import React from 'react';
import { CQV_VTME_THEME } from './cqvVtmePageTheme';

type Props = {
  aditivo?: number;
  renegociacao?: number;
  apta?: number;
  naoApta?: number;
  semMarcacao?: number;
  compact?: boolean;
};

/** Resumo de linhas (Aditivo/Renegociação + aptidão) reaproveitado no card por analista e no
 * modal de detalhe — mesma formatação nos dois lugares. */
const CqvVtmeLinesSummary: React.FC<Props> = ({
  aditivo = 0,
  renegociacao = 0,
  apta = 0,
  naoApta = 0,
  semMarcacao = 0,
  compact = false,
}) => (
  <div style={{ fontSize: compact ? '0.85em' : 12 }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
      <span style={{ color: CQV_VTME_THEME.muted }}>Linhas Aditivo</span>
      <span style={{ fontWeight: 700, color: CQV_VTME_THEME.text }}>{aditivo}</span>
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, marginTop: 2 }}>
      <span style={{ color: CQV_VTME_THEME.muted }}>Linhas Renegociação</span>
      <span style={{ fontWeight: 700, color: CQV_VTME_THEME.text }}>{renegociacao}</span>
    </div>
    {renegociacao > 0 ? (
      <div style={{ fontSize: '0.9em', color: CQV_VTME_THEME.muted, marginTop: 2 }}>
        {apta} apta · {naoApta} não apta · {semMarcacao} sem marcação
      </div>
    ) : null}
  </div>
);

export default CqvVtmeLinesSummary;
